var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.735 0H2.26501C1.92306 0.000268305 1.58853 0.0994258 1.30204 0.285438C1.01554 0.471451 0.789394 0.736321 0.651039 1.0479C0.512685 1.35948 0.468073 1.70438 0.522617 2.04073C0.577161 2.37708 0.728517 2.69043 0.958315 2.94274L6.79594 9.3396V15.3725C6.79599 15.4905 6.82939 15.606 6.89232 15.7059C6.95525 15.8058 7.04516 15.8859 7.15173 15.9372C7.23691 15.9791 7.3307 16.0006 7.42567 16C7.56879 15.9999 7.70761 15.9512 7.81925 15.8619L9 14.9208L10.9679 13.3521C11.0416 13.2934 11.101 13.2189 11.1419 13.1342C11.1828 13.0495 11.204 12.9567 11.2041 12.8627V9.3396L17.0417 2.94274C17.2715 2.69043 17.4228 2.37708 17.4774 2.04073C17.5319 1.70438 17.4873 1.35948 17.349 1.0479C17.2106 0.736321 16.9845 0.471451 16.698 0.285438C16.4115 0.0994258 16.0769 0.000268305 15.735 0Z",
    fill: "#3F4D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.eb5d3051ce7fbec86fb861b2dcab2928.svg";
export { ForwardRef as ReactComponent };